export const LEGAL = {
  privacy: {
    title: "Privacy Policy",
    updated: "Last updated: June 2026",
    sections: [
      {
        h: "1. Introduction",
        p: "Maktran Cyber (\u201cwe\u201d, \u201cus\u201d, or \u201cour\u201d) is committed to protecting your privacy. This Privacy Policy explains how we collect, use, disclose, and safeguard your information when you visit our website or engage our cybersecurity services."
      },
      {
        h: "2. Information We Collect",
        p: "We may collect information that you voluntarily provide to us, such as your name, email address, company name, and any message you submit through our consultation form. We may also automatically collect limited technical data such as your browser type, device information, and pages visited."
      },
      {
        h: "3. How We Use Your Information",
        p: "We use the information we collect to respond to your inquiries, provide and improve our services, communicate with you about consultations and engagements, and comply with legal obligations. We do not sell your personal information to third parties."
      },
      {
        h: "4. How We Share Information",
        p: "We may share information with trusted service providers who assist us in operating our website and delivering our services (for example, our email delivery provider), and where required by law. All such providers are bound by confidentiality obligations."
      },
      {
        h: "5. Data Security",
        p: "As a cybersecurity firm, we apply industry-standard technical and organizational measures to protect your information against unauthorized access, alteration, disclosure, or destruction. However, no method of transmission over the Internet is 100% secure."
      },
      {
        h: "6. Data Retention",
        p: "We retain personal information only for as long as necessary to fulfill the purposes described in this policy, unless a longer retention period is required or permitted by law."
      },
      {
        h: "7. Your Rights",
        p: "Depending on your jurisdiction, you may have the right to access, correct, or delete your personal information, or to object to or restrict certain processing. To exercise these rights, contact us at info@maktrancyber.com."
      },
      {
        h: "8. Cookies",
        p: "Our website may use essential cookies and similar technologies to ensure proper functionality and to understand how visitors use our site. You can control cookies through your browser settings."
      },
      {
        h: "9. Changes to This Policy",
        p: "We may update this Privacy Policy from time to time. Any changes will be posted on this page with an updated revision date."
      },
      {
        h: "10. Contact Us",
        p: "If you have questions about this Privacy Policy, please contact us at info@maktrancyber.com."
      }
    ]
  },
  terms: {
    title: "Terms of Service",
    updated: "Last updated: June 2026",
    sections: [
      {
        h: "1. Acceptance of Terms",
        p: "By accessing or using the Maktran Cyber website and services, you agree to be bound by these Terms of Service. If you do not agree with any part of these terms, please do not use our website or services."
      },
      {
        h: "2. Services",
        p: "Maktran Cyber provides cybersecurity consulting services, including digital forensics and incident response, penetration testing, and security analysis. The specific scope, deliverables, and fees for any engagement will be defined in a separate written agreement."
      },
      {
        h: "3. Use of the Website",
        p: "You agree to use our website only for lawful purposes. You may not attempt to gain unauthorized access to any part of the website, interfere with its operation, or use it to transmit malicious code or conduct unauthorized security testing."
      },
      {
        h: "4. Intellectual Property",
        p: "All content on this website, including text, graphics, logos, and images, is the property of Maktran Cyber or its licensors and is protected by applicable intellectual property laws. You may not reproduce or distribute it without our written permission."
      },
      {
        h: "5. Confidentiality",
        p: "Any confidential information exchanged during an engagement will be handled in accordance with the confidentiality provisions of the applicable service agreement between you and Maktran Cyber."
      },
      {
        h: "6. Disclaimer of Warranties",
        p: "The website and its content are provided \u201cas is\u201d without warranties of any kind, whether express or implied. While we strive to provide accurate information, we do not guarantee that the website will be error-free or uninterrupted."
      },
      {
        h: "7. Limitation of Liability",
        p: "To the fullest extent permitted by law, Maktran Cyber shall not be liable for any indirect, incidental, or consequential damages arising from your use of the website. Liability for any engagement is governed by the applicable service agreement."
      },
      {
        h: "8. Third-Party Links",
        p: "Our website may contain links to third-party websites. We are not responsible for the content, privacy practices, or availability of those external sites."
      },
      {
        h: "9. Governing Law",
        p: "These Terms of Service are governed by and construed in accordance with applicable laws of the jurisdiction in which Maktran Cyber operates, without regard to conflict of law principles."
      },
      {
        h: "10. Contact Us",
        p: "For questions regarding these Terms of Service, please contact us at info@maktrancyber.com."
      }
    ]
  }
};
